import React, { useEffect } from 'react';
import { Wrapper, Background } from './styles';

import { Menu } from '../../../components/Menu';

import { useAuth } from '../../../hooks/Auth';
import FooterLayout from '../../Footer';
import PopupComponent from '../../../components/PopupContainer';

import Particles from 'react-particles-js';
import ImageSliderBackground from '../../../components/ImageBackgroundSlider';
import { usePages } from '../../../hooks/Pages';
import { useParams } from 'react-router-dom';
import { useLanguage } from '../../../hooks/Language';


const DefaultLayout: React.FC = ({ children }) => {

  const { menu } = usePages();
  const { projectHash } = useParams<Record<string, any>>();

  const { changeLanguage } = useLanguage();

  useEffect(() => {

    if (projectHash === 'mechanical-trombectomy-training-pathways-for-latam-argentina') {
      changeLanguage('es')
    }
    else {
      changeLanguage('ptBr')
    }

  }, [projectHash])

  return (
    <>
      <Wrapper> <Menu menuList={menu} fixedMenu={false} />
        {children}
        <FooterLayout />
        <PopupComponent />

      </Wrapper>
      {/*   <ImageSliderBackground slides={['/apoio/background/BG_amazonia_1_1.jpeg',
        '/apoio/background/BG_amazonia_2_1.jpeg',
        '/apoio/background/BG_amazonia_3_1.jpeg',
      '/apoio/background/BG_amazonia_4_1.jpeg',
  '/apoio/background/BG_amazonia_5_1.jpeg']} speed={15000}/>
      <Particles
        params={{
          particles: {
            lineLinked: {
              enable: false,
            },
            move: {
              speed: 2,
              direction: 'top-right',

              outModes: {
                default: 'out',
                left: 'out',
                right: 'out',
                bottom: 'out',
                top: 'out',
              },
            },
            shape: {
              type: 'circle',
           
            },
            color: { value: 'rgb(0,200,100)' },

            number: {
              density: {
                enable: true,
                value_area: 2400,
              },
              value: 60,
            },
            size: {
              value: 12,
              random: true,
            },
          },
        }}
        style={{
          position: 'fixed',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          width: '100%',
          height: '100%',
          zIndex: 1
        }}
      />*/}
    </>
  );
};

export default DefaultLayout;
